
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image className='bigImage' file={require('images/grafik_food.jpg')} mdxType="Image" />
    <p>{`Eine kleine, kohlenhydratreiche Mahlzeit – beispielsweise Müesli oder
Vollkornbrot – kurz vor dem Zu-Bett-Gehen kann nächtliche und morgendliche
Attacken unter Umständen verhindern. Sie entstehen oft durch den
Blutzuckerabfall während der Nacht. Empfehlenswert ist auch ein warmes
kohlenhydratreiches Frühstück in Ruhe sowie regelmässige Mittag- und Abendessen
zu festen Zeiten. Eine sehr spezielle Form der Behandlung wird in einem `}<Link href='https://www.peoplespharmacy.com/articles/how-to-get-migraine-relief-without-spending-a-fortune/' mdxType="Link">{`US-Forum
für Betroffene`}</Link>{` beschrieben: Früh im Migräneanfall hilft offenbar einigen
Personen der «Brain Freeze». Dabei wird zum Beispiel eiskalter «Frappucino»,
Slush – also ein halb gefrorenes Trinkeis –, ein kalter Milkshake oder ähnlich
Eiskaltes erst im Mund behalten und dann rasch getrunken. Eiskaltes Wasser
scheint demnach nicht zu funktionieren. Wissenschaftlich überprüft wurde das
bisher aber nicht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;